var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummaryScheduleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14286 3.42857H15.8571V1.28571C15.8571 0.575893 16.4304 0 17.1429 0C17.8554 0 18.4286 0.575893 18.4286 1.28571V3.42857H20.5714C22.4625 3.42857 24 4.96339 24 6.85714V24C24 25.8911 22.4625 27.4286 20.5714 27.4286H3.42857C1.53482 27.4286 0 25.8911 0 24V6.85714C0 4.96339 1.53482 3.42857 3.42857 3.42857H5.57143V1.28571C5.57143 0.575893 6.14464 0 6.85714 0C7.56964 0 8.14286 0.575893 8.14286 1.28571V3.42857ZM2.57143 24C2.57143 24.4714 2.955 24.8571 3.42857 24.8571H20.5714C21.0429 24.8571 21.4286 24.4714 21.4286 24V10.2857H2.57143V24Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryScheduleIcon);
export default __webpack_public_path__ + "static/media/Summary_ScheduleIcon.cb5786db7e914094534ae8b86ddaf09d.svg";
export { ForwardRef as ReactComponent };